import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import uploadIcon from '../../../../images/uploadNewIcon.svg';
import excelImage from '../../../../images/excel_image.svg';
import editIcon from '../../../../images/pencil-alt.svg';
import dustbinIcon from '../../../../images/dustbin-alt.svg';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import "./styles.css";
import DatePicker from "react-datepicker";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBDataTable } from 'mdbreact';




const urlParams = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('id');
const poNumber = urlParams.get('po_num');
let statusStyle;


class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            supplierCodeData: [],
            reasonStatus: [],
            posts: [],
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            tax_type: "",
            dataHistory: [],
            tax_community: "",
            inventoryOwner: null,
            uploadedFileName: "",
            sectionStatus: {
                pricingDetails: false,
            },
            dropDownData: [],
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            taxType: [],
            availableOwners: [],
            taxCommunity: [],
            username_val: '',
            itemDetails: [],
            password: '',
            errors: {},
            poDetails: [],
            reasonModal: false,
            productAttributes: [],
            productPricing: [],
            uomDetails: [],
            isAccordionOpen: true,
            sectionStatus: {
                itemDetails: false,
                productAttributes: false,
                pricingDetails: false,
                uomDetails: false
            }
        };
    }

    Failedtoggle = () => {
        this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew = () => {
        this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    reasonToggle = () => {
        this.setState((prevState) => ({ reasonModal: !prevState.reasonModal }));
    }

    toggleBack = () => {
        window.location.href = "/upload/item_master";  
    }

    editPO = () => {
        window.location.href = "/receiving/edit_po_details?id="+paramValue+"&po_num="+poNumber;  
    }

    

    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };*/
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(
            { [name]: value, errors: { ...this.state.errors, [name]: '' } },
            () => {
                this.setState({
                    sectionStatus: {
                        itemDetails: this.isSectionComplete('itemDetails'),
                        productAttributes: this.isSectionComplete('productAttributes'),
                        pricingDetails: this.isSectionComplete('pricingDetails'),
                        uomDetails: this.isSectionComplete('uomDetails'),
                    }
                });
            }
        );
    };
    isSectionComplete = (section) => {
        switch (section) {
            case 'itemDetails':
                return (
                    this.state.item_code &&
                    this.state.item_name &&
                    this.state.item_type &&
                    this.state.item_category &&
                    this.state.sub_category &&
                    this.state.brand &&
                    this.state.sub_brand &&
                    this.state.hsn_code &&
                    this.state.hht_item_desc
                );
            case 'productAttributes':
                return (
                    this.state.ean &&
                    this.state.upc &&
                    this.state.ean_each_length &&
                    this.state.ean_each_breadth &&
                    this.state.ean_each_height 
                );
            case 'pricingDetails':
                return (
                    this.state.mrp &&
                    this.state.std_cost &&
                    this.state.per_qty
                );
            case 'uomDetails':
                return (
                    this.state.purchase_uom &&
                    this.state.std_purchase_price &&
                    this.state.sales_uom
                );
            default:
                return false;
        }
    };

    componentDidMount() {
        this.getDropDownData();
        this.fetchBinData();
         const accordion = document.getElementById("create_item_accordian");
         const accordion_buttons = document.getElementsByClassName("accordion__button");
         const accordion_items = document.getElementsByClassName("accordion__item");
         const accordion__panel = document.getElementsByClassName("accordion__panel");

        if (accordion) {
            accordion.style.setProperty("width", "92%", "important");
            accordion.style.setProperty("border", "0px", "important");
        }


        if (accordion_buttons.length > 0) {  // Check if elements exist
            for (let button of accordion_buttons) {
                button.style.setProperty("background-color", "#fff", "important");
                button.style.setProperty("font-weight", "bold", "important");
            }

        }

        if (accordion_items.length > 0) {  // Check if elements exist
            for (let button of accordion_items) {
                button.style.setProperty("margin-bottom", "10px", "important");
                button.style.setProperty("border", "0px", "important");
                
            }

        }

         if (accordion__panel.length > 0) {  // Check if elements exist
            for (let button of accordion__panel) {
                button.style.setProperty("background-color", "#fff", "important");
                
                
            }

        }
    }

    fetchBinData(page = 1){
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })

      const url = `/receiving/po-creation/${paramValue}`;
      API.get(url)
      /*callapiobj.get('/tax/v1/item-list/product/', { param: payload })*/

      .then(response => response.data)

      .then(data => {

         console.log("PO Data",data);
         

         this.setState({
            poDetails: data.data,
            posts: data.data.po_items,
            /*productAttributes: data.data.product_attributes,
            productPricing: data.data.product_pricing,
            uomDetails: data.data.uom_details,
            dataHistory: data.data.data_history,*/
         })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log(this.state.tableRows);

      });
    }

    assemblePosts= () => {
    

        let posts =this.state.posts.map((post, index) => {

        return (

        {
          

          sl_no: index+1,
          item_code: post.item_code,
          item_desc: post.item_description,
          mrp: post.po_date,
          item_level_discount: post.item_level_discount,
          qty: post.qty,
          per_tax: post.per_tax,
          post_tax: post.post_tax,
          uom: post.uom,
          cost: post.cost,
          action: (
                <div className="action-menu">
                  <button className="action-menu-button">⋮</button>
                  <div className="action-menu-content">
                    <div style={{fontSize: 12}} onClick={() => this.removeItem(post)}><img style={{width: '11%', marginRight: 6}} src={editIcon} />Remove Item</div>
                    <div style={{fontSize: 12}} onClick={() => this.editItem(post)}><img style={{width: '11%', marginRight: 6}} src={dustbinIcon} /> Edit Item</div>
                    
                  </div>
                </div>
            )

          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }

    statusUpdate = (status) => {
        let payload

        if(status == "approve"){
            this.setState({
                approveLoader: true
            })
            payload = {
                status: 1,
                "remark":"product pending",

            }; 
        }else{
            this.setState({
                rejectLoader: true
            })

             payload = {
                status: 5,
                "remark":"product pending",
                "reason": parseInt(this.state.reason_status)
            }; 

        }

        
        const url = `/receiving/po-creation/approval/${paramValue}`;

        API.patch(url, { param: payload })
        .then((response) => {
          
            console.log(response);
          if(response.data.status === true){
            this.setState({
                success_message: response.data.message,
                reasonModal: false,
                approveLoader: false,
                rejectLoader: false
            })
            this.toggleNew();
            this.fetchBinData();

          }else{
            this.setState({
                failed_message: response.data.message,
                reasonModal: false,
                approveLoader: false,
                rejectLoader: false
            })
            this.Failedtoggle();
            this.fetchBinData();
          }

          
        })
        .catch((error) => {
            if(error.response.status == "400") {
                this.setState({
                    failed_message: error.response.data.data.status[0],
                    reasonModal: false,
                    approveLoader: false,
                    rejectLoader: false
                });
                this.Failedtoggle();
                this.fetchBinData();
            }else{
                console.log(error);
            }
          
        });
    };


    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("File selected:", file.name);
            // You can update state or handle file upload here
        }
    };

    getDropDownData = () => {
        API.get('/receiving/po-creation/reasons')
            .then((response) => response.data)
            .then((data) => {
                console.log(data);

                this.setState({
                    reasonStatus: data.data
                })
            })
            .catch((error) => console.error(error));
    };

    createItem = () => {
        console.log(this.state.tax_community)
        this.setState({
            loading: true
        })
        const payload = {
            item_details : {
                "lb_sku_product_name": this.state.item_name,
                "product_type": 0,
                "category": this.state.item_category,
                "sub_category": this.state.sub_category,
                "sub_division": this.state.division,
                "brand": this.state.brand,
                "sub_brand": this.state.sub_brand,
                "base_pack_code": this.state.basepack,
                "status": "1",
                "hsn_code": this.state.hsn_code,
                "item_description": this.state.hht_item_desc
            },
            product_attributes: {
               "ean": this.state.ean,
               "sku":this.state.item_code,
               "ean_each": {
                   "length": this.state.ean_each_length,
                   "breadth": this.state.ean_each_breadth,
                   "height": this.state.ean_each_height
               },
               "ean_cases": {
                   "length": 0.0,
                   "breadth": 0.0,
                   "height": 0.0
               },
               "upc": 12,
               
            },
            product_pricing: {
               "mrp": this.state.mrp,
               "std_cost": this.state.std_cost,
               "per_qty": this.state.per_qty
            },
           uom_details: {
               "purchase_uom": this.state.purchase_uom,
               "std_purchase_price": this.state.std_purchase_price,
               "sales_uom": this.state.sales_uom
           }

        };

        API.post('/tax/v1/item-list/product/', { param: payload })
            .then((response) => response.data)
            .then((data) => {
                console.log(data)

                if(data.status == "success"){
                   this.setState({
                    success_message: data.message,
                    modalNew: true,
                    loading: false
                }); 
                }else{
                    this.setState({
                        failed_message: data.message,
                        failedModal: true,
                        loading: false
                    });
                }

                /*this.setState({
                    success_message: data[0].message,
                    username_val: data[0].username,
                    password: data[0].password,
                    modalNew: true,
                });*/

            })
           .catch((error) => {
              console.log(error.response.data.message)
                if (error.response.status == "400") {
                    this.setState({
                        failed_message: error.response.data.message,
                        failedModal: true,
                    });
                } else {
                    console.log(error);
                }
            });
    }
      handleAccordionToggle = (isOpen) => {
        this.setState({ isAccordionOpen: isOpen });
    };

    render() {
        const { errors, modalNew, failedModal, dropDownData, poDetails, productAttributes, uomDetails, productPricing, dataHistory, itemDetails, reasonModal } = this.state;
        console.log()
        const isActive = itemDetails.status == 3;
        if(poDetails.status){
            const status = poDetails.status.value;
              statusStyle = {
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#000',
                backgroundColor: '#f0f0f0',
              };

              if (status === "Approved") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E6F4EA', 
                  color: '#34A853',          
                };
              } else if (status === "Pending for Approval") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#FEF1CC', 
                  color: '#FB8C00',           
                };
              }else if (status === "Rejected") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#FF3C00', 
                  color: '#FFF0EF',           
                };
              }else if (status === "Cancelled") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E6E6E6', 
                  color: '#777777',           
                };
              }else if (status === "In Progress") {
                statusStyle = {
                  ...statusStyle,
                  backgroundColor: '#E8F1FF', 
                  color: '#5C9DFF',           
                };
              }



        }
         

        const data = {

          columns: [

            {

              label:'S.NO',

              field:'sl_no',
              sort: '',
              width: 50

            },

            {

              label:'Item Code',

              field:'item_code',
              sort: '',
              width: 100

            },
            {

              label:'Item Desc',

              field:'item_desc',
              sort: '',
              width: 130

            },
            {

              label:'MRP',

              field:'mrp',
              sort: '',
              width: 80

            },

            {

              label:'Item Level Discount',

              field:'item_level_discount',
              sort: '',
              width: 150

            },

            {

              label:'QTY',

              field:'qty',
              sort: '',
              width: 80

            },
           
           {

              label:'Pre Tax',

              field:'pre_tax',
              sort: '',
              width: 100

            },
           
           {

              label:'Post Tax',

              field:'post_tax',
              sort: '',
              width: 100

            },

            {
              label:'UOM',

              field:'uom',
              sort: '',
              width: 100

            },

            {
              label:'Cost',

              field:'cost',
              sort: '',
              width: 100

            },

            {
              label:'',

              field:'action',
              sort: '',
              width: 100

            },
           
           


            

          ],

          rows:this.state.tableRows,

        }



        return (
            <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>
                {/*<div className="statusStyle" >
                    <span  className="dotStyle"></span>
                    <span style={{ color: isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                </div>*/}
                <div className="status-container">
                    <div className="status-left">
                        <span style={{marginRight: 8, color: '#777777', fontWeight: 'bold'}}> PO Status </span>
                       {/* <span className={`status-dot ${poDetails.status.value == "Approved" ? 'status-dot-active' : poDetails.status.value == "Cancelled" ? 'status-dot-inactive' : 'status-dot-pending'}`}></span>
                        <span>
                            {poDetails.status.value}
                        </span>*/}
                        <span style={statusStyle}>{poDetails.status ? poDetails.status.value : ""}</span>

                    </div>
                    <button className="edit-button" style={{fontWeight: 'bold'}} onClick={this.editPO}>
                       <i style={{fontWeight: 'bold'}} className="fa fa-edit edit-icon" aria-hidden="true"></i> Edit PO
                    </button>
                </div>
                
                
                    <Accordion 
                        id="create_item_accordian" 
                       style={{ width: '100%', maxWidth: '100vw' }} 
                        allowMultipleExpanded 
                        allowZeroExpanded
                        onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
                    >
                        {/* Section 1 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Request Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">PO Number </Label>
                                            <Input
                                                type="text"
                                                name="po_number"
                                                value={poDetails.po_number}
                                                onChange={this.handleChange}
                                                required
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Warehouse </Label>
                                            <Input
                                                type="text"
                                                name="warehouse"
                                                value={poDetails.warehouse ? poDetails.warehouse.name : ""}
                                                onChange={this.handleChange}
                                                required
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        
                                            <Label for="city">PO Date </Label>
                                            <div id="date_picker_container" style={{ position: 'relative' }}>
                                              <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={poDetails.po_date ? new Date(poDetails.po_date) : null}
                                                  onChange={this.FromDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="PO Date"
                                                  format='yyyy-MM-dd'
                                                  disabled
                                              />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>


                                        
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Expected Delivery Date </Label>
                                            <div id="date_picker_container" style={{ position: 'relative' }}>
                                                <DatePicker
                                                  id="ledger_fromdate"
                                                  selected={poDetails.expected_delivery_date ? new Date(poDetails.expected_delivery_date) : null}
                                                  onChange={this.FromDateChange}
                                                  className="ledger_fromdate"
                                                  placeholderText="Expected Delivery Date"
                                                  format='yyyy-MM-dd'
                                                  disabled
                                              />
                                              <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category </Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={poDetails.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{poDetails.sub_category}</option>
                                                <option value={dropDownData.sub_category}>{dropDownData.sub_category}</option>
                                                {this.state.taxCommunity.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division</Label>
                                            <select
                                                name="division"
                                                className="form-control"
                                                value={poDetails.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{poDetails.division}</option>
                                                <option value={dropDownData.division}>{dropDownData.division}</option>

                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/* Section 2 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Vendor Information</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Supplier Code</Label>
                                            <select
                                                className="form-control"
                                                /*value={poDetails.supplier_code.name}*/
                                                style={{ fontSize: 13 }}
                                                name="supplier_code"
                                                onChange={this.handleChangeEvent}
                                                disabled
                                            >
                                                <option value="">{poDetails.supplier_code ? poDetails.supplier_code.name : "Select"}</option>
                                                {this.state.supplierCodeData.length > 0 &&
                                                  this.state.supplierCodeData.map((items) => {
                                                    return (
                                                      <option value={items.name}>
                                                        {" "}
                                                        {items.name}
                                                      </option>
                                                    );
                                                  })}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                   
                                </Row>
                                <Row form>
                                     <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Vendor Name</Label>
                                            <Input
                                                type="number"
                                                name="vendor_name"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Loaction</Label>
                                            <Input
                                                type="number"
                                                name="location"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Trade Name</Label>
                                            <Input
                                                type="number"
                                                name="trade_name"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                 <Row form>
                                     <Col md={12}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Full Address</Label>
                                            <Input
                                                type="text"
                                                name="full_address"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                  <span className="accordian_title">PO Bulk Upload</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>

                            <AccordionItemPanel>
                                <span style={{color: 'black'}}> Items List Upload </span>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                    gap: "2rem",
                                    marginTop: 15,
                                  }}
                                >


                            

                                {/* Right Section - Image */}
                                {/*<div style={{ flex: 1, minWidth: "300px",  }}>
                                    <div className="file-name-container">
                                        <img
                                          src={excelImage}
                                          alt="PO Bulk Upload"
                                          style={{
                                            width: "10%",
                                            height: "auto",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                            marginLeft: 10
                                          }}
                                        />
                                        <span style={{color: '#33A0FF', marginLeft: 12, fontSize: 13}}>File Name</span>
                                        

                                    </div>
                                  </div>*/}
                                </div>

                                <div id="masterTableContainer" className="taxmaster_table">
                  
                                    <div
                                      className="d-flex justify-content-end align-items-center"
                                      style={{ width: "100%" }}
                                    >
                                      {/* Search Input */}
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={this.state.searchTerm}
                                        onChange={this.handleSearchInput}
                                        onKeyDown={this.handleKeyDown}
                                        style={{ width: 200, marginRight: 10 }}
                                        id="searchInput"
                                      />

                                      {/* Download Icon */}
                                      {this.state.isDownlding ? (
                                        <FontAwesomeIcon
                                          icon={faSpinner}
                                          spin
                                          style={{ fontSize: "18px", color: "#919193", cursor: "not-allowed" }}
                                        />
                                      ) : (
                                        <a
                                          onClick={() => this.downloadExcel()}
                                          style={{
                                            fontSize: "18px",
                                            color: "#919193",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faDownload} />
                                        </a>
                                      )}
                                    </div>

                    
                                    <MDBDataTable
                                    striped
                                    
                                    bordered
                                    sortable={true}
                                    hover
                                    data={data}
                                    paging={false}
                                    searching= {false}
                                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
                                  />
                  
                                </div>
                            
                            </AccordionItemPanel>
                        </AccordionItem>


                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Total </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Total Bill Amount</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                value={poDetails.total_bill_amount}
                                                disabled
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Bill Level Discount (RPA)</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                value={poDetails.bill_level_discount}
                                                disabled
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Invoice Attachment </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={12}>
                                       <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "flex-start",
                                            gap: "2rem",
                                            
                                          }}
                                        >

                                            {/* Right Section - Image */}
                                            <div style={{ flex: 1, minWidth: "300px",  }}>
                                                <div className="file-name-container-view">
                                                    <img
                                                      src={excelImage}
                                                      alt="PO Bulk Upload"
                                                      style={{
                                                        width: "5%",
                                                        height: "auto",
                                                        borderRadius: "8px",
                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                        marginLeft: 10
                                                      }}
                                                    />
                                                    <span style={{ marginLeft: 12, fontSize: 13}}>{poDetails.invoice_attachment ? poDetails.invoice_attachment : "No Uploaded File"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>


                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Terms & Condition </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="email">Terms & Condition</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                value={poDetails.term_condition}
                                                disabled
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="mobile">Notes or Description</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                disabled
                                                value={poDetails.notes_description}
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>

                   
                        <div style={{
                           
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                            padding: '15px 0',
                            textAlign: 'center'
                        }}>
                            <button 
                                onClick={this.reasonToggle} 
                                style={{
                                    backgroundColor: 'white',
                                    border: '2px solid red',
                                    color: 'red',
                                    padding: '8px 22px',
                                    fontSize: '16px',
                                    marginRight: '10px',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                            {/*{this.state.rejectLoader && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px", color: 'red' }}
                              />
                            )}*/}
                            Reject
                                
                            </button>

                            <button 
                                onClick={() => this.statusUpdate("approve")} 
                                id="createUserBtn" 
                                style={{
                                    backgroundColor: 'white',
                                    border: '2px solid green',
                                    color: 'green',
                                    padding: '8px 22px',
                                    fontSize: '16px',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                            {this.state.approveLoader && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px", color: 'green' }}
                              />
                            )}
                                Approve
                            </button>
                        </div>
                   


                <Modal isOpen={reasonModal} backdrop="static" toggle={this.reasonToggle}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.reasonToggle}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <div style={{width: '80%', paddingLeft: '15%'}}>
                   
                        <span style={{fontSize: 17, marginBottom: 18, marginLeft: -52}}> Reason for Rejecting PO - </span>
                        <Label style={{textAlign: 'left', width: '100%', marginTop: 20}} for="city">Select Reason </Label>
                        <select
                            name="reason_status"
                            className="form-control"
                            value={this.state.reason_status}
                            style={{ fontSize: 13 }}
                            onChange={this.handleChange}
                            
                        >
                            <option value="">Select</option>
                            {this.state.reasonStatus.map((item) => (
                                <option key={item.id} value={item.id}>{item.description}</option>
                            ))}
                        </select>

                   
                    </div>                
                  </div>
                  <ButtonToolbar className="modal__footer">
                    {/*<Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleBack}
                    >
                      Cancel
                    </Button>*/}
                    <button 
                            onClick={this.reasonToggle} 
                            style={{
                                backgroundColor: 'white',
                                border: '2px solid #FBBB00',
                                color: 'black',
                                padding: '8px 22px',
                                fontSize: '16px',
                                marginRight: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "black" }}
                      className="modal_ok"
                      onClick={() => this.statusUpdate("reject")}
                    >
                     {this.state.rejectLoader && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px", color: 'black' }}
                      />
                    )}
                      Reject
                     
                    </Button>
                  </ButtonToolbar>
                </Modal>


                   

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h4>{this.state.success_message} </h4>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleNew}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
                </Modal>

                <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4>{this.state.failed_message} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                </Modal>



              
            </div>
        );
    }
}

export default HorizontalForm;
